import clsx from "clsx";
import { forwardRef, useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { ControlSize } from "../types";
import { ControlGroupContext } from "./context";
import { controlGroupSizeStyles } from "./styles";

export interface ControlGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: ControlSize;
}

const ControlGroup = forwardRef<HTMLDivElement, ControlGroupProps>(
  ({ className, size = "md", role = "group", style, ...props }, ref) => {
    const contextValue = useMemo(() => ({ size }), [size]);

    return (
      <ControlGroupContext.Provider value={contextValue}>
        <div
          {...props}
          ref={ref}
          role={role}
          data-slot="control-group"
          data-size={size}
          style={{ ...controlGroupSizeStyles[size], ...style }}
          className={twMerge(
            clsx(
              "isolate flex w-full min-w-0 items-stretch",
              "[&>.control-group-participant]:relative",
              "[&>.control-group-participant:not(:first-child)]:-ms-px",
              "[&>.control-group-participant_.control-group-surface]:rounded-none",
              "[&>.control-group-participant:first-child_.control-group-surface]:rounded-s-sm",
              "[&>.control-group-participant:last-child_.control-group-surface]:rounded-e-sm",
              "[&>.control-group-participant:has(>.control-group-surface>.control-group-segment:only-child>.control-group-action:only-child)+.control-group-participant:has(>.control-group-surface>.control-group-segment:only-child>.control-group-action:only-child)>.control-group-surface]:border-s-0!",
              "[&>.control-group-participant:has([data-invalid])]:z-10",
              "[&>.control-group-participant:focus-within]:z-20",
              "[&>.control-group-participant:has([aria-expanded=true])]:z-20",
            ),
            className,
          )}
        />
      </ControlGroupContext.Provider>
    );
  },
);

export default ControlGroup;
